import { render, staticRenderFns } from "./AddSupplierModal.vue?vue&type=template&id=04187a4a&"
import script from "./AddSupplierModal.vue?vue&type=script&lang=js&"
export * from "./AddSupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports